<script>
import baseInput from './baseInput'
export default {

    name: 'custom-selectable-box',

    mixins: [ baseInput ],

    props:
    {
        colLeft:String,
        colRight:String,
        type: String,
        label: String,
        icon: String,
        checked: Boolean,
        disabled: Boolean,
        readonly: Boolean,
        name: String,
    },

    data()
    {
        return {
            uid: this._uid,

        }
    }

}
</script>

<template lang="html">
    <div class="selectable-box container">
        <div class="row">
            <div :class="'col-'+colLeft">
                <input
                :id="'choice_' + uid"
                v-if="checked"
                :type="type"
                :name="name"
                class="custom-control-input"
                v-model="internalValue"
                :disabled="disabled"
                :readonly="readonly"
                checked
                :required="required"
                >

                <input
                v-else
                :id="'choice_' + uid"
                :type="type"
                :name="name"
                class="custom-control-input"
                v-model="internalValue"
                :disabled="disabled"
                :readonly="readonly"
                :required="required"
                >

                <div class="custom-input">
                    <i @click="internalValue=!internalValue" v-if="internalValue" class="fas fa-check-circle cp text-purple"></i>
                    <i @click="internalValue=!internalValue" v-else class="fal fa-circle cp text-placeholder-color"></i>
                </div>

            </div>
            <div :class="'col-'+colRight">
                <label :for="'choice_' + uid" class="label-box" :class="{'notselected': !internalValue}">
                    <i v-if="icon" class="fa-lg mr-2" :class="icon"></i>
                    {{ label }}
                </label>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/forms/elements/selectableBox.vue